
import {changeUrlParam} from '@baidu/health-utils/lib/url/changeUrlParam';
import {callHandlers} from '@baidu/health-tool-box-bridge';
import {isDoctorApp} from '@/utils/utils';


/**
 * @file 分享
 * @author yantingxi
 */

const IconImageUrl = 'https://expertimg.bj.bcebos.com/expertcms%2Fmed%2Fallhealth%2Fbd_health_logo.png';

/**
 * 加载一个外部的js库
 *
 * @param {string} src js地址
 * @return {Promise}
 */
const loadJS = (src: any) => {

    return new Promise((resolve, reject) => {
        const ref = document.getElementsByTagName('script')[0];
        let script = document.createElement('script');
        script.src = src;
        script.async = true;
        ref?.parentNode?.insertBefore(script, ref);
        script.onload = () => {
            script = null;
            resolve(script);
        };
        script.onerror = e => {
            script = null;
            reject(e);
        };
    });
};


export interface ShareInfo {
    title?: string;
    content?: string;
    keywords?: string;
    imageUrl?: string | HeadAddImg[];
    alt?: string;
    url?: string;
}

export interface ShareConfig {
    debug?: boolean;
    appId?: string;
    timestamp: string;
    nonceStr: string;
    signature: string;
}

export interface HeadAddImg {
    id?: string;
    url?: string;
    alt?: string;
}

/**
 * 为dom添加图片
 *
 * @param {string} id
 * @param {string} url
 * @param {string} alt
 * @param {string} element
 * @param {string} productLine
 */
const headAddImg = (id: string, url: string, alt: string, element: any, productLine: string) => {
    if (productLine && productLine === 'exam') {
        const metaImgContent = document.createElement('meta');
        metaImgContent.id = id;
        metaImgContent.content = url;
        metaImgContent.setAttribute('property', 'og:image');
        element.appendChild(metaImgContent);
    } else {
        const img = document.createElement('img');
        img.id = id;
        img.src = url;
        img.alt = alt;
        element.appendChild(img);
        element.style.display = 'none';
    }
};

// eslint-disable-next-line complexity, max-statements
export const shareBdBox = (info: ShareInfo, productLine = '') => {
    try {
        const {title = '', content = '', keywords = '', imageUrl = '', alt = ''} = info;
        // eslint-disable-next-line no-negated-condition, no-underscore-dangle
        if (!window.__shareInfoInit) {
            const headElement = document.getElementsByTagName('head')[0];
            const titleElement = document.getElementsByTagName('title')[0];
            const metaContent = document.createElement('meta');
            const metaKeywords = document.createElement('meta');
            const div = document.createElement('div');
            titleElement.innerText = title;
            metaContent.name = 'description';
            metaContent.content = content;
            metaContent.id = 'shareMetaContent';
            metaKeywords.name = 'keywords';
            metaKeywords.content = keywords || content;
            metaKeywords.id = 'shareMetakeywords';
            headElement.insertBefore(div, titleElement);
            headElement.insertBefore(metaContent, titleElement);
            headElement.insertBefore(metaKeywords, titleElement);
            const element = productLine === 'exam' ? headElement : div;
            // 判断imageUrl是否为数组，且长度大于1
            if (Object.prototype.toString.call(imageUrl) === '[object Array]' && imageUrl.length > 0) {
                // eslint-disable-next-line array-callback-return
                (imageUrl as HeadAddImg[]).map((item, index) => {
                    headAddImg(
                        item.id || `shareImg${index}`,
                        item.url || IconImageUrl,
                        item.alt || '百度健康',
                        element,
                        productLine
                    );
                });
            } else {
                headAddImg(
                    'shareImg',
                    imageUrl as string || IconImageUrl,
                    alt || '百度健康',
                    element,
                    productLine
                );
            }
            // eslint-disable-next-line no-underscore-dangle
            window.__shareInfoInit = true;
        } else {
        // 更新
            const titleElement = document.getElementsByTagName('title')[0];
            const metaContent: any = document.querySelector('head #shareMetaContent');
            const metaKeywords: any = document.querySelector('head #shareMetakeywords');
            titleElement.innerText = title;
            metaContent.content = content;
            metaKeywords.content = content;

            // 判断imageUrl是否为数组，且长度大于1
            if (Object.prototype.toString.call(imageUrl) === '[object Array]' && imageUrl.length > 0) {
                // eslint-disable-next-line array-callback-return
                (imageUrl as HeadAddImg[]).map((item, index) => {
                    const querySelector = item.id || `head #shareImg${index}`;
                    const img: any = document.querySelector(querySelector);
                    img.src = item.url || IconImageUrl;
                    img.alt = item.alt || '百度健康';
                });
            } else {
                const img: any = document.querySelector('head #shareImg');
                img.src = imageUrl || IconImageUrl;
                img.alt = alt || '百度健康';
            }
        }

    } catch (e) {
        // eslint-disable-next-line no-console
        console.log(e);
    }
};

/**
 * 微信分享 https://developers.weixin.qq.com/doc/offiaccount/OA_Web_Apps/JS-SDK.html
 *
 * @param {Object} shareInfo 分享信息
 * @param {Object} config 配置
 */
export const shareWX = (shareInfo: ShareInfo, config: ShareConfig) => {
    const defaultConfig = {
        // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        debug: false,
        // 必填，公众号的唯一标识
        appId: 'wx1c36ea5e2231b169',
        // 必填，生成签名的时间戳
        timestamp: '',
        // 必填，生成签名的随机串
        nonceStr: '',
        // 必填，签名
        signature: '',
        // 必填，需要使用的JS接口列表
        jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData'],
    };

    // eslint-disable-next-line no-underscore-dangle
    const __initWXShare = () => {
        wx.config(Object.assign(defaultConfig, config));
        wx.ready(() => {
            // 自定义“分享给朋友”及“分享到QQ”按钮的分享内容
            wx.updateAppMessageShareData({
                // 分享标题
                title: shareInfo.title,
                // 分享描述
                desc: shareInfo.content,
                link: shareInfo.url,
                imgUrl: shareInfo.imageUrl || IconImageUrl,
                success: () => {},
            });
            // 自定义“分享到朋友圈”及“分享到QQ空间”按钮的分享内容
            wx.updateTimelineShareData({
                // 分享标题
                title: shareInfo.title,
                // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                link: shareInfo.url,
                // 分享图标
                imgUrl: shareInfo.imageUrl,
                success: () => {},
            });
        });


    };

    loadJS('//res.wx.qq.com/open/js/jweixin-1.6.0.js')
        .then(() => {
            __initWXShare();
        })
        .catch(() => {
            loadJS('//res2.wx.qq.com/open/js/jweixin-1.6.0.js')
                .then(() => {
                    __initWXShare();
                });
        });
};

export const shareDoctorBox = (shareInfo: ShareInfo) => {

    let shareUrl = window.location.href;
    if (isDoctorApp()) {
        shareUrl = changeUrlParam(shareUrl, 'channel', 'appshare');
        // eslint-disable-next-line max-len
        shareUrl = changeUrlParam(shareUrl, 'client', '7961c5a61d2e71f8317c126d96353e930702fbfa8a171210c2170549fee2bfe5');
    }

    callHandlers.common.setShare({
        onNavi: '1',
        title: shareInfo.title,
        content: shareInfo.content,
        imageUrl: shareInfo.imageUrl,
        shareUrl: encodeURI(shareUrl),
        style: 0,
        ubcPage: 'content-external-channel',
    });
};

export default (shareInfo: ShareInfo, config?: ShareConfig) => {
    // eslint-disable-next-line global-require
    const ua = require('@searchfe/user-agent');
    document.getElementsByTagName('title')[0].innerText = shareInfo && shareInfo.title || '百度健康';

    // 同时适配手百和h5分享
    if (ua.isBaiduBox()) {
        shareBdBox(shareInfo);
    }

    if (ua.isWeixinApp() && config) {
        shareWX(shareInfo, config);
    }

    if (isDoctorApp()) {
        shareDoctorBox(shareInfo);
    }
};
